import { Button } from "core/components/form-controls";
import AppLayout from "core/layouts/AppLayout";
import { useCustomNavigate } from "core/utils/helper";
import { RouterName } from "core/router";
import SignupSuccess from 'core/assets/icons/signup/success.svg';
import { _t } from "core/language";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";


const SignUpSuccess = () => {
  const navigate = useCustomNavigate();
  const navigateTo = useNavigate();

  const [signUpModal, setSignUpModal] = useState({state:false});
  const location = useLocation();
  const [signUpByMenu, setSignUpByMenu] = useState('');

  useEffect(() => {
    
    if ((window as any).webViewCallGetListPath) {
      (window as any).webViewCallGetListPath([(window as any).location?.pathname])
    }
    (window as any).backFromDeviceAndroid = function() {
      navigateTo(RouterName.LOGIN)
    }
    return () => {
      (window as any).backFromDeviceAndroid = undefined
    }
  }, [])

  useEffect(() => {
    if(location?.search && location?.search.includes('signUpByMenu')){  
      const url = new URLSearchParams(location?.search).get('signUpByMenu');
      if(url){
        setSignUpByMenu(url)
      }
    }
    if(location?.search && location?.search.includes('signUpModal')){  
      setSignUpModal({state:true})
    }
  }, [location])

  const handleGoBack = () => {
    navigate(RouterName.LOGIN+`${signUpModal.state ? '?signupSuccess=true' : ''}`+`${signUpByMenu ? '?signUpByMenu='+signUpByMenu : ''}`)
  }

  
  return (
    <AppLayout className={"login-client-page"}>
      <div className="mt-1">
        <section className="flex flex-col items-center w-full text-base tracking-tighter text-center bg-white">
          <div className="flex flex-col items-center w-full text-base tracking-tighter text-center bg-white transform -translate-x-1/2 -translate-y-1/2 fixed top-2/4 left-2/4">
            <img loading="lazy" className="object-contain aspect-square w-[72px]" src={SignupSuccess} alt="" />
            <h1 className="mt-8 text-xl font-bold tracking-tighter text-neutral-900">
              {_t('auth.LabelRegisterComplete')}
            </h1>
            <p className="mt-2 leading-tight text-neutral-500">
              {_t('auth.LabelLoginToUseService')}
            </p>
          </div>
          <div className="absolute left-0 bottom-0 w-full px-4">
            <Button size="lg" primary label={_t('auth.LabelLogin')} onClickBtn={handleGoBack} classBtn="w-full mb-[50px] bg-primary" />
          </div>
        </section>
      </div >

    </AppLayout >
  );
};

export default SignUpSuccess;
